import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import themeColors from '../../assets/styles/themeColors';
import AccountEinForm from '../../components/Forms/AccountEinForm';
import { HeadingSubtitle } from '../../components/Heading';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import { useMenu } from '../../hooks/useMenu';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import { APPLICANT_TYPES } from '../../util/constants';

const SecureAccountEin = () => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const settings = useSelector(selectSettings);
  const { BrokerName } = settings;
  const formId = 'ein_form';
  const [eventType, setEventType] = useState(null);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
      formId={formId}
      setEventType={setEventType}
    >
      <Helmet>
        <title>
          {t('titleTagEin', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <HeadingSubtitle mb={32} color={themeColors.colorTextSecondary}>
        {t('secureAccountEin.title')}
      </HeadingSubtitle>
      <AccountEinForm
        applicantType={APPLICANT_TYPES.BUSINESS}
        nextPath={activeItem?.nextPath}
        formId={formId}
        setEventType={setEventType}
        eventType={eventType}
      />
    </OnBoardingContainer>
  );
};

export default SecureAccountEin;
